export default "__VITE_ASSET__d15ada55__"